import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { getAccessToken } from '../../utils/auth';

const EditTimeModal = ({ open, onClose, onSave, initialData }) => {
  const [startTime, setStartTime] = useState(initialData.start_time || '');
  const [endTime, setEndTime] = useState(initialData.end_time || '');
  const [lunchBreak, setBreak] = useState(initialData.break || '');
  
  const handleSave = async () => {
	  
    try {
	  const token = await getAccessToken();
      const response = await fetch(
        'https://app.recyconelement.dk/api/time/update_time_registration.php',
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,	
          },
          body: JSON.stringify({
            id: initialData.id,
            startTime: startTime,
            endTime: endTime,
            break: lunchBreak,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        onSave(result);
        onClose();
      } else {
        console.error('Error updating time registration:', result.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error updating time registration:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Time Entry</DialogTitle>
      <DialogContent>
        <TextField
          label="Start Time"
          type="time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
		  inputProps={{ step: 60 }}
          fullWidth
          margin="normal"
        />
        <TextField
          label="End Time"
          type="time"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Frokost"
          type="time"
          value={lunchBreak}
          onChange={(e) => setBreak(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditTimeModal;
